var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside }
          })
        : _vm._e(),
      _c("sidebar", { staticClass: "sidebar-container" }),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          _c(
            "div",
            { class: { "fixed-header": _vm.fixedHeader } },
            [_c("navbar")],
            1
          ),
          _c("app-main", {
            key: _vm.iframeKey,
            staticClass: "iframe-container"
          }),
          _c(
            "div",
            {
              directives: [{ name: "drag", rawName: "v-drag" }],
              staticClass: "container",
              attrs: { id: "drag" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "robot-container",
                  on: { click: _vm.SelectFunc }
                },
                [
                  _c("div", { staticClass: "robot" }),
                  _c("div", { staticClass: "robot-circle" })
                ]
              )
            ]
          ),
          _c(
            "el-dialog",
            {
              staticClass: "robot-dialog",
              attrs: {
                fullscreen: false,
                title: null,
                footer: null,
                modal: false,
                "close-on-click-modal": "",
                visible: _vm.robotModalVisible,
                width: "830px",
                center: ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.robotModalVisible = $event
                }
              }
            },
            [
              _c("i", {
                staticClass: "el-icon-close close-icon",
                on: { click: _vm.robotModalController }
              }),
              _c("iframe", {
                attrs: {
                  id: "robot-iframe",
                  src: "/robot/index.html",
                  width: "100%",
                  height: "640"
                }
              })
            ]
          ),
          _c(
            "el-drawer",
            {
              attrs: {
                modal: false,
                visible: _vm.drawer,
                "modal-append-to-body": false,
                "append-to-body": false,
                size: "800px",
                wrapperClosable: false,
                "show-close": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.drawer = $event
                }
              }
            },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "draw-title" }, [
                  _c("div", { staticClass: "draw-title-left" }, [
                    _c("img", {
                      staticClass: "draw-title-img",
                      attrs: { src: require("../assets/qaRobot.png"), alt: "" }
                    }),
                    _c("p", { staticClass: "draw-title-top" }, [
                      _vm._v(_vm._s(_vm.options[_vm.model]))
                    ])
                  ]),
                  _c(
                    "div",
                    [
                      _c("el-switch", {
                        attrs: { "active-text": "自动播放语音" },
                        on: { change: _vm.speechSwitchChange },
                        model: {
                          value: _vm.speechSwitch,
                          callback: function($$v) {
                            _vm.speechSwitch = $$v
                          },
                          expression: "speechSwitch"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "draw-fold" }, [
                  _c(
                    "div",
                    {
                      staticClass: "draw-fold-close",
                      style: {
                        color: _vm.foldGray ? "#797979" : "var(--mainColor)"
                      },
                      on: {
                        click: _vm.closeChat,
                        mouseenter: _vm.foldEnter,
                        mouseleave: _vm.foldLeave
                      }
                    },
                    [
                      _vm.foldGray
                        ? _c("fold-gray", {
                            staticStyle: { "margin-bottom": "10px" }
                          })
                        : _c("fold-icon", {
                            staticStyle: { "margin-bottom": "10px" }
                          }),
                      _vm._v(" 折叠窗口 ")
                    ],
                    1
                  )
                ])
              ]),
              [
                _c("div", { staticClass: "draw-content" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      ref: "drawContent",
                      staticClass: "draw-content-discuss",
                      attrs: { id: "drawContentScroll" }
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "draw-content-discuss-list" },
                        [
                          _c(
                            "li",
                            { staticClass: "draw-content-discuss-list-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                                    attrs: { src: _vm.assistantImages, alt: "" }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                                },
                                [
                                  _vm.model == "assistant"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "draw-content-discuss-list-item-user-talking-content"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#333",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "我是晓合，您可以问我任何问题。我知道的知识有限，因此我的回答难免出现错误，请您谅解。"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.model == "riQa" || _vm.model == "instQa"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "draw-content-discuss-list-item-user-talking-content"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#333",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "我是晓合，您有用的政策咨询助手。我知道的知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我："
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#1890FF",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px",
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getQuestion(
                                                    "银行审慎监管主要包括哪些方面？"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "银行审慎监管主要包括哪些方面？"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#1890FF",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px",
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getQuestion(
                                                    "流动资金贷款贷后管理主要包括哪些内容？"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "流动资金贷款贷后管理主要包括哪些内容？"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm._l(_vm.answerMsg, function(item, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass: "draw-content-discuss-list-item"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "draw-content-discuss-list-item-user",
                                    class: {
                                      "draw-content-discuss-list-item-user-left":
                                        _vm.answerMsg[index] &&
                                        _vm.answerMsg[index].type == "left",
                                      "draw-content-discuss-list-item-user-right":
                                        _vm.answerMsg[index] &&
                                        _vm.answerMsg[index].type == "right"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "draw-content-discuss-list-item-user-img",
                                      attrs: {
                                        src:
                                          _vm.answerMsg[index].type == "right"
                                            ? _vm.images
                                            : _vm.assistantImages,
                                        alt: ""
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "draw-content-discuss-list-item-user-talking",
                                    class: {
                                      "draw-content-discuss-list-item-user-talking-left":
                                        _vm.answerMsg[index] &&
                                        _vm.answerMsg[index].type == "left",
                                      "draw-content-discuss-list-item-user-talking-right":
                                        _vm.answerMsg[index] &&
                                        _vm.answerMsg[index].type == "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "draw-content-discuss-list-item-user-talking-content"
                                      },
                                      [
                                        _c("p", {
                                          staticStyle: {
                                            "font-size": "14px",
                                            "font-family":
                                              "PingFang SC, PingFang SC-Regular",
                                            "font-weight": "500",
                                            "text-align": "left",
                                            color: "#333333",
                                            "line-height": "22px",
                                            "white-space": "pre-wrap",
                                            "margin-top": "0",
                                            "margin-bottom": "0"
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.answerMsg[index].msg
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm.answerMsg[index] &&
                                    _vm.answerMsg[index].type == "left" &&
                                    _vm.answerMsg[index].title &&
                                    _vm.answerMsg[index].title.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "draw-content-discuss-list-item-user-talking-resource"
                                          },
                                          _vm._l(
                                            _vm.answerMsg[index].title,
                                            function(ele, i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: i,
                                                  staticStyle: { width: "100%" }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "draw-content-discuss-list-item-user-talking-resource-item",
                                                      attrs: {
                                                        title:
                                                          i +
                                                          1 +
                                                          "." +
                                                          ele.title
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.toInst(ele)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          i +
                                                            1 +
                                                            "." +
                                                            ele.title
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          }),
                          _c("div", {
                            staticStyle: { width: "1px", height: "100px" }
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      ref: "drawContent",
                      staticClass: "draw-content-discuss",
                      attrs: { id: "instDrawContentScroll" }
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "draw-content-discuss-list" },
                        [
                          _c(
                            "li",
                            { staticClass: "draw-content-discuss-list-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                                    attrs: { src: _vm.assistantImages, alt: "" }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "draw-content-discuss-list-item-user-talking-content"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "#333",
                                            "line-height": "18px",
                                            "white-space": "pre-wrap",
                                            "margin-top": "0",
                                            "margin-bottom": "8px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "我是晓合，您有用的政策咨询助手。我知道的知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我："
                                          )
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "#1890FF",
                                            "line-height": "18px",
                                            "white-space": "pre-wrap",
                                            "margin-top": "0",
                                            "margin-bottom": "8px",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getQuestion(
                                                "银行审慎监管主要包括哪些方面？"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "银行审慎监管主要包括哪些方面？"
                                          )
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "#1890FF",
                                            "line-height": "18px",
                                            "white-space": "pre-wrap",
                                            "margin-top": "0",
                                            "margin-bottom": "8px",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getQuestion(
                                                "流动资金贷款贷后管理主要包括哪些内容？"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "流动资金贷款贷后管理主要包括哪些内容？"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._l(_vm.instAnswerMsg, function(item, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass: "draw-content-discuss-list-item"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "draw-content-discuss-list-item-user",
                                    class: {
                                      "draw-content-discuss-list-item-user-left":
                                        _vm.instAnswerMsg[index] &&
                                        _vm.instAnswerMsg[index].type == "left",
                                      "draw-content-discuss-list-item-user-right":
                                        _vm.instAnswerMsg[index] &&
                                        _vm.instAnswerMsg[index].type == "right"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "draw-content-discuss-list-item-user-img",
                                      attrs: {
                                        src:
                                          _vm.instAnswerMsg[index].type ==
                                          "right"
                                            ? _vm.images
                                            : _vm.assistantImages,
                                        alt: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm.instAnswerMsg[index].type == "left" &&
                                _vm.instAnswerMsg[index].audio &&
                                !_vm.instAnswerMsg[index].loading
                                  ? _c("div", { staticClass: "qaAudio" }, [
                                      _c("img", {
                                        staticStyle: {
                                          width: "24px",
                                          height: "24px"
                                        },
                                        attrs: {
                                          src: require("@/assets/firstPage/volice.png"),
                                          alt: ""
                                        }
                                      }),
                                      _vm.instAnswerMsg[index].play
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "16px",
                                              height: "16px",
                                              cursor: "pointer",
                                              margin: "0 8px"
                                            },
                                            attrs: {
                                              src: require("@/assets/firstPage/start.png"),
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.startAudio(index)
                                              }
                                            }
                                          })
                                        : _c("img", {
                                            staticStyle: {
                                              width: "16px",
                                              height: "16px",
                                              cursor: "pointer",
                                              margin: "0 8px"
                                            },
                                            attrs: {
                                              src: require("@/assets/firstPage/pause.png"),
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.pauseAudio($event)
                                              }
                                            }
                                          })
                                    ])
                                  : _vm._e(),
                                _vm.instAnswerMsg[index].type == "left" &&
                                _vm.instAnswerMsg[index].loading
                                  ? _c(
                                      "div",
                                      { staticClass: "qaAudioLoading" },
                                      [
                                        _vm._v(" LOADING "),
                                        _c("img", {
                                          staticStyle: {
                                            width: "12px",
                                            height: "12px",
                                            "margin-top": "3px",
                                            "margin-left": "5px"
                                          },
                                          attrs: {
                                            src: require("@/assets/firstPage/loading.gif")
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "draw-content-discuss-list-item-user-talking",
                                    class: {
                                      "draw-content-discuss-list-item-user-talking-left":
                                        _vm.instAnswerMsg[index] &&
                                        _vm.instAnswerMsg[index].type == "left",
                                      "draw-content-discuss-list-item-user-talking-right":
                                        _vm.instAnswerMsg[index] &&
                                        _vm.instAnswerMsg[index].type == "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "draw-content-discuss-list-item-user-talking-content",
                                        staticStyle: { position: "relative" }
                                      },
                                      [
                                        _c("p", {
                                          staticStyle: {
                                            "font-size": "14px",
                                            "font-family":
                                              "PingFang SC, PingFang SC-Regular",
                                            "font-weight": "500",
                                            "text-align": "left",
                                            color: "#333333",
                                            "line-height": "24px",
                                            "white-space": "pre-wrap",
                                            "margin-top": "0",
                                            "margin-bottom": "0"
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.instAnswerMsg[index].msg
                                            )
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.buttonShow &&
                                                  _vm.instAnswerMsg[index]
                                                    .type == "left" &&
                                                  _vm.instAnswerMsg[index]
                                                    .title &&
                                                    _vm.instAnswerMsg[index]
                                                      .title[0] &&
                                                    _vm.instAnswerMsg[index]
                                                      .title[0].systemId ===
                                                      "LC_IE" &&
                                                  index ==
                                                    _vm.instAnswerMsg.length -
                                                      1,
                                                expression:
                                                  "buttonShow && instAnswerMsg[index].type == 'left' && (instAnswerMsg[index].title && instAnswerMsg[index].title[0] && instAnswerMsg[index].title[0].systemId === 'LC_IE' ) && index == instAnswerMsg.length-1"
                                              }
                                            ],
                                            staticClass: "checkReg",
                                            on: {
                                              click: function($event) {
                                                return _vm.sendMsgRi()
                                              }
                                            }
                                          },
                                          [_vm._v(" 查看外规 ")]
                                        )
                                      ]
                                    ),
                                    _vm.instAnswerMsg[index] &&
                                    _vm.instAnswerMsg[index].type == "left" &&
                                    _vm.instAnswerMsg[index].title &&
                                    _vm.instAnswerMsg[index].title.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "draw-content-discuss-list-item-user-talking-resource"
                                          },
                                          _vm._l(
                                            _vm.instAnswerMsg[index].title,
                                            function(ele, i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: i,
                                                  staticStyle: { width: "100%" }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            ele.systemId !=
                                                            "LC_LLM",
                                                          expression:
                                                            "ele.systemId != 'LC_LLM'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "draw-content-discuss-list-item-user-talking-resource-item",
                                                      attrs: {
                                                        title:
                                                          ele.systemId ==
                                                          "LC_LLM"
                                                            ? ""
                                                            : i +
                                                              1 +
                                                              "." +
                                                              ele.title
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          ele.systemId ==
                                                          "LC_LLM"
                                                            ? ""
                                                            : _vm.toInst(ele)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (ele.systemId ==
                                                          "LC_LLM"
                                                            ? ""
                                                            : i + 1 + ".") +
                                                            ele.title
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            ele.systemId ==
                                                            "LC_LLM",
                                                          expression:
                                                            "ele.systemId == 'LC_LLM'"
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        padding: "0",
                                                        margin: "0",
                                                        position: "absolute",
                                                        right: "120px",
                                                        color: "#ccc"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "大语言模型生成，仅供参考"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm.aiLoadingMask
                            ? _c(
                                "li",
                                {
                                  key: "laster",
                                  staticClass: "draw-content-discuss-list-item"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "draw-content-discuss-list-item-user-img",
                                        attrs: {
                                          src: _vm.assistantImages,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "draw-content-discuss-list-item-user-talking-content"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-family":
                                                  "PingFang SC, PingFang SC-Regular",
                                                "font-weight": "500",
                                                "text-align": "left",
                                                color: "#333333",
                                                "line-height": "22px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "0",
                                                display: "flex",
                                                "align-items": "center"
                                              }
                                            },
                                            [
                                              _vm._v(" 好的，正在思考… "),
                                              _c("img", {
                                                staticClass:
                                                  "draw-content-discuss-list-item-user-img",
                                                attrs: {
                                                  src: require("@/assets/loading.gif"),
                                                  alt: ""
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c("div", {
                            staticStyle: { width: "1px", height: "100px" }
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  false
                    ? _c(
                        "div",
                        {
                          ref: "drawContent",
                          staticClass: "draw-content-discuss",
                          attrs: { id: "riDrawContentScroll" }
                        },
                        [
                          _c(
                            "ul",
                            { staticClass: "draw-content-discuss-list" },
                            [
                              _c(
                                "li",
                                {
                                  staticClass: "draw-content-discuss-list-item"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "draw-content-discuss-list-item-user draw-content-discuss-list-item-user-left"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "draw-content-discuss-list-item-user-img draw-content-discuss-list-item-user-left",
                                        attrs: {
                                          src: _vm.assistantImages,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "draw-content-discuss-list-item-user-talking draw-content-discuss-list-item-user-talking-left"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "draw-content-discuss-list-item-user-talking-content"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#333",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "我是晓合，您有用的政策咨询助手。我知道的1知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我："
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#1890FF",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px",
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getQuestion(
                                                    "银行审慎监管主要包括哪些方面？"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "银行审慎监管主要包括哪些方面？"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#1890FF",
                                                "line-height": "18px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "8px",
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getQuestion(
                                                    "流动资金贷款贷后管理主要包括哪些内容？"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "流动资金贷款贷后管理主要包括哪些内容？"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._l(_vm.riAnswerMsg, function(item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass:
                                      "draw-content-discuss-list-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "draw-content-discuss-list-item-user",
                                        class: {
                                          "draw-content-discuss-list-item-user-left":
                                            _vm.riAnswerMsg[index] &&
                                            _vm.riAnswerMsg[index].type ==
                                              "left",
                                          "draw-content-discuss-list-item-user-right":
                                            _vm.riAnswerMsg[index] &&
                                            _vm.riAnswerMsg[index].type ==
                                              "right"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "draw-content-discuss-list-item-user-img",
                                          attrs: {
                                            src:
                                              _vm.riAnswerMsg[index].type ==
                                              "right"
                                                ? _vm.images
                                                : _vm.assistantImages,
                                            alt: ""
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "draw-content-discuss-list-item-user-talking",
                                        class: {
                                          "draw-content-discuss-list-item-user-talking-left":
                                            _vm.riAnswerMsg[index] &&
                                            _vm.riAnswerMsg[index].type ==
                                              "left",
                                          "draw-content-discuss-list-item-user-talking-right":
                                            _vm.riAnswerMsg[index] &&
                                            _vm.riAnswerMsg[index].type ==
                                              "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "draw-content-discuss-list-item-user-talking-content"
                                          },
                                          [
                                            _c("p", {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-family":
                                                  "PingFang SC, PingFang SC-Regular",
                                                "font-weight": "500",
                                                "text-align": "left",
                                                color: "#333333",
                                                "line-height": "22px",
                                                "white-space": "pre-wrap",
                                                "margin-top": "0",
                                                "margin-bottom": "0"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.riAnswerMsg[index].msg
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm.riAnswerMsg[index] &&
                                        _vm.riAnswerMsg[index].type == "left" &&
                                        _vm.riAnswerMsg[index].title &&
                                        _vm.riAnswerMsg[index].title.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "draw-content-discuss-list-item-user-talking-resource"
                                              },
                                              _vm._l(
                                                _vm.riAnswerMsg[index].title,
                                                function(ele, i) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: i,
                                                      staticStyle: {
                                                        width: "100%"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "draw-content-discuss-list-item-user-talking-resource-item",
                                                          attrs: {
                                                            title:
                                                              i +
                                                              1 +
                                                              "." +
                                                              ele.title
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.toInst(
                                                                ele
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              (ele.systemId ==
                                                              "LC_LLM"
                                                                ? ""
                                                                : i + 1 + ".") +
                                                                ele.title
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _c("div", {
                                staticStyle: { width: "1px", height: "50px" }
                              })
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "draw-content-input" }, [
                    _c(
                      "div",
                      { staticClass: "draw-content-input-search" },
                      [
                        !_vm.disClick
                          ? _c("el-input", {
                              ref: "inputName",
                              staticStyle: {
                                "font-size": "14px",
                                "font-family":
                                  "PingFang SC, PingFang SC-Regular",
                                "font-weight": "400",
                                "text-align": "left",
                                color: "#333333",
                                "line-height": "20px",
                                height: "100% !important",
                                border: "none"
                              },
                              attrs: {
                                placeholder: "请输入你想要咨询的问题",
                                autosize: true,
                                type: "textarea",
                                clearable: "",
                                resize: "none"
                              },
                              on: {
                                blur: function($event) {
                                  _vm.question = $event.target.value.trim()
                                }
                              },
                              nativeOn: {
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  _vm.disClick ? "" : _vm.carriageReturn($event)
                                }
                              },
                              model: {
                                value: _vm.question,
                                callback: function($$v) {
                                  _vm.question = $$v
                                },
                                expression: "question"
                              }
                            })
                          : _vm._e(),
                        _vm.disClick
                          ? _c(
                              "p",
                              {
                                staticClass: "draw-content-input-cancelButton",
                                on: { click: _vm.cancelQa }
                              },
                              [
                                _c("i", {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "18px",
                                    height: "18px",
                                    "background-color": "#174ae4",
                                    "margin-right": "5px"
                                  }
                                }),
                                _vm._v(" 停止响应 ")
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    !_vm.disClick
                      ? _c(
                          "div",
                          {
                            staticClass: "draw-content-input-send",
                            class: {
                              "draw-content-input-send-active":
                                _vm.question.trim().length > 0
                            },
                            on: {
                              click: function($event) {
                                _vm.disClick && _vm.question.trim().length > 0
                                  ? ""
                                  : _vm.sendBtn()
                              }
                            }
                          },
                          [_vm._v(" 发送 ")]
                        )
                      : _vm._e()
                  ])
                ])
              ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }